import { render, staticRenderFns } from "./SoftSkills.vue?vue&type=template&id=57daad26"
import script from "./SoftSkills.vue?vue&type=script&lang=js"
export * from "./SoftSkills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports